import React from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

import Spinner from '@dashboard/components/Spinner';
import Tooltip from '@dashboard/components/Tooltip';
import { Button } from '@dashboard/components/ui/button';
import isAbandonedAbandonment from '@dashboard/services/abandonment/isAbandonedAbandonment';

// A canceled order's confirmation would hand back its voided tickets or disabled licence key.
export const resendConfirmationOffReason = (record, noun) =>
  (record.orderStatus === 'canceled' && `This ${noun} has been canceled`) ||
  (isAbandonedAbandonment(record) && 'This checkout was abandoned') ||
  '';

export const ResendConfirmationButton = ({ offReason, onClick, sending }) => {
  const button = (
    <Button variant="outline" size="sm" onClick={onClick} disabled={sending || Boolean(offReason)}>
      Resend confirmation
      {sending ? <Spinner /> : <ArrowPathIcon />}
    </Button>
  );

  if (!offReason) return button;

  return (
    <Tooltip label={offReason} asChild>
      {/* A disabled button fires no pointer events, so the focusable span carries the tooltip. */}
      <span tabIndex={0} className="inline-flex rounded-md">
        {button}
      </span>
    </Tooltip>
  );
};
